import clz from 'classnames';
import { FunctionComponent, useContext } from 'react';
import { observer } from 'mobx-react';
import dynamic from 'next/dynamic';

import navConfig from 'public/data/page/nav.json';
import styles from './PageTemplate.module.sass';
import NavBurger from './NavBurger';
import FoldedList from '../common/FoldedList/FoldedList';
import NavBar from './NavBar';
import NotificationBanner from '../common/NotificationBanner';
import { HomePageStoreContext } from '../../model/context/home-page.context';
import ButtonLink from '../common/ButtonLink';
import Footer from './Footer';

const DynamicUserLoginMod = dynamic(() => import('../LoginMod/UserLoginMod'));
const DynamicSignupForm = dynamic(() => import('../LoginMod/SignupForm'));

const PageTemplate: FunctionComponent = observer(({ children }) => {
    const { navLinks } = navConfig;

    const { popoutStore } = useContext(HomePageStoreContext);

    const BtnList = (
        <div className={styles.btnGroup}>
            <ButtonLink
                text="User Login"
                bgColor="#6EBDD0"
                textColor="white"
                onClick={() => popoutStore.toggleUserLoginModal(true)}
            />
            <ButtonLink
                text="Business Signup"
                bgColor="#75D0C5"
                textColor="white"
                onClick={() => popoutStore.toggleSignup(true)}
            />
        </div>
    );

    return (
        <div
            className={clz(styles.overview, {
                [styles.unscrollable]: popoutStore.anyGlobalPopout,
            })}
        >
            <NotificationBanner>
                <div className={styles.notification}>
                    Does something look different to you? We’ve refreshed our website to bring you a
                    more seamless Kover experience. Take a look around and stay Kovered!
                    <br />- The Kover Team
                </div>
            </NotificationBanner>
            <NavBar navLinks={navLinks}>{BtnList}</NavBar>
            <NavBurger>
                <FoldedList list={navLinks} />
                {BtnList}
            </NavBurger>
            <DynamicUserLoginMod
                onClose={() => popoutStore.toggleUserLoginModal(false)}
                open={popoutStore.userLoginOpen}
            />
            <DynamicSignupForm
                open={popoutStore.signupOpen}
                onClose={() => popoutStore.toggleSignup(false)}
            />
            {children}
            <Footer />
        </div>
    );
});

export default PageTemplate;
